import { useQuery } from '@tanstack/react-query';
import {
  ProjectPresetsApi,
  ProjectPresetsSearchRequest,
} from 'osep-generator-service-client-v1';
import { PROJECT_PRESETS_QUERY_KEY } from '../../utils/consts';
import { useApiConfig } from '../useApiConfig';

function useProjectPresetsSearchQuery(
  projectPresetsSearchRequest: ProjectPresetsSearchRequest,
) {
  const { getApiConfig, axiosInstance } = useApiConfig();

  return useQuery({
    queryKey: [PROJECT_PRESETS_QUERY_KEY, projectPresetsSearchRequest],
    queryFn: async () => {
      const config = await getApiConfig();
      const api = new ProjectPresetsApi(config, undefined, axiosInstance);

      const result = (
        await api.searchProjectPresets(projectPresetsSearchRequest)
      ).data;
      return result;
    },
  });
}

export default useProjectPresetsSearchQuery;
